const MIN_STACKED_FRACTION_PARTS = 2;

function replaceStackedFractions(text: string): string {
  return text.replace(/\\S([^;\\]*);/g, (_match, body: string) => {
    if (body.includes('#')) {
      const [numerator, denominator] = body.split('#');
      return `${numerator}/${denominator ?? ''}`;
    }
    const caretParts = body.split('^').filter((part) => part.length > 0);
    if (caretParts.length >= MIN_STACKED_FRACTION_PARTS) {
      return `${caretParts[0]}/${caretParts[1]}`;
    }
    return body;
  });
}

/**
 * Strips MTEXT control wrappers and common control codes for on-screen display.
 * The raw `content` is preserved separately for round-trip persistence.
 */
export function sanitizeCadTextLine(raw: string): string {
  if (!raw) {
    return '';
  }

  let text = raw;

  text = text.replace(/\0/g, '');
  text = text.replace(/\\0/g, '');
  text = replaceStackedFractions(text);
  text = text.replace(/\\[A-Za-z][^;\\]*;/g, '');
  text = text.replace(/\\[A-Za-z]/g, '');
  text = text.replace(/\\~/g, ' ');
  text = text.replace(/\\\\/g, '\\');
  text = text.replace(/\\{/g, '{');
  text = text.replace(/\\}/g, '}');

  return text.replace(/[ \t]+/g, ' ').trim();
}

/**
 * Splits MTEXT/CAD content into display lines (paragraph breaks) and sanitizes each line.
 * Backend import stores paragraph breaks as newlines ({@link ForeignCadPlainTextLinuxFix}).
 */
export function splitMTextDisplayLines(raw: string): string[] {
  if (!raw) {
    return [];
  }

  const normalized = raw
    .replace(/\r\n/g, '\n')
    .replace(/\0/g, '')
    .replace(/\\0/g, '');

  const parts = normalized.split(/\\P|\n/);
  return parts.map((part) => sanitizeCadTextLine(part));
}

/** Single-line preview (properties panel); joins paragraphs with spaces. */
export function sanitizeCadText(raw: string): string {
  const lines = splitMTextDisplayLines(raw);
  if (lines.length === 0) {
    return '';
  }
  return lines.join(' ');
}

/** Multiline display (textarea); preserves paragraph breaks as newlines. */
export function sanitizeCadTextMultiline(raw: string): string {
  const lines = splitMTextDisplayLines(raw);
  if (lines.length === 0) {
    return '';
  }
  return lines.join('\n');
}
